import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { ClockCounterIcon } from '@moia-dev/pace-icons'
import { FetchAreaRoutes } from './FetchAreaRoutes'

export const FetchAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={FetchAreaRoutes.route}
      Icon={ClockCounterIcon}
    />
  )
}
